module.exports = {
      id: "product-category-permanent-usage",
      viewBox: "0 0 137.716 167.39",
      url: __webpack_public_path__ + "assets/sprite-28816f.svg#product-category-permanent-usage",
      toString: function () {
        return this.url;
      }
    }